/**
 * @generated SignedSource<<6f25121222d6b6875673c976f28f24cd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddUserPushTokenInput = {
  clientMutationId?: string | null | undefined;
  token?: string | null | undefined;
};
export type useAddUserPushTokenMutation$variables = {
  input: AddUserPushTokenInput;
};
export type useAddUserPushTokenMutation$data = {
  readonly addUserPushToken: {
    readonly query: {
      readonly currentUserUnreadCount: number | null | undefined;
    } | null | undefined;
    readonly user: {
      readonly isPushNotificationsEnabled: boolean | null | undefined;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useAddUserPushTokenMutation = {
  response: useAddUserPushTokenMutation$data;
  variables: useAddUserPushTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentUserUnreadCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPushNotificationsEnabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddUserPushTokenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AddUserPushTokenPayload",
        "kind": "LinkedField",
        "name": "addUserPushToken",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useAddUserPushTokenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AddUserPushTokenPayload",
        "kind": "LinkedField",
        "name": "addUserPushToken",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "92e5e317d38b2aed8929ead86e7df59a",
    "id": null,
    "metadata": {},
    "name": "useAddUserPushTokenMutation",
    "operationKind": "mutation",
    "text": "mutation useAddUserPushTokenMutation(\n  $input: AddUserPushTokenInput!\n) {\n  addUserPushToken(input: $input) {\n    query {\n      currentUserUnreadCount\n      id\n    }\n    user {\n      isPushNotificationsEnabled\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "07d687f8bd0e7449fc190af1da269a86";

export default node;
